// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * IMS Management API
 * Management API for the IMS catalog: partitions, isolation units, and clusters, returned in a Kubernetes-familiar metadata/spec/status envelope (ADR-0008).
 *
 * The version of the OpenAPI document: 1.0
 * Contact: team-aura-infra@neotechnology.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { Condition } from './Condition';
import {
  ConditionFromJSON,
  ConditionFromJSONTyped,
  ConditionToJSON,
  ConditionToJSONTyped,
} from './Condition';

/**
 *
 * @export
 * @interface IsolationUnitStatus
 */
export interface IsolationUnitStatus {
  /**
   *
   * @type {string}
   * @memberof IsolationUnitStatus
   */
  awsAccountId?: string;
  /**
   *
   * @type {string}
   * @memberof IsolationUnitStatus
   */
  azureSubscriptionId?: string;
  /**
   *
   * @type {Array<Condition>}
   * @memberof IsolationUnitStatus
   */
  conditions?: Array<Condition>;
  /**
   *
   * @type {string}
   * @memberof IsolationUnitStatus
   */
  gcpProjectId?: string;
}

/**
 * Check if a given object implements the IsolationUnitStatus interface.
 */
export function instanceOfIsolationUnitStatus(
  value: object,
): value is IsolationUnitStatus {
  return true;
}

export function IsolationUnitStatusFromJSON(json: any): IsolationUnitStatus {
  return IsolationUnitStatusFromJSONTyped(json, false);
}

export function IsolationUnitStatusFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): IsolationUnitStatus {
  if (json == null) {
    return json;
  }
  return {
    awsAccountId:
      json['aws_account_id'] == null ? undefined : json['aws_account_id'],
    azureSubscriptionId:
      json['azure_subscription_id'] == null
        ? undefined
        : json['azure_subscription_id'],
    conditions:
      json['conditions'] == null
        ? undefined
        : (json['conditions'] as Array<any>).map(ConditionFromJSON),
    gcpProjectId:
      json['gcp_project_id'] == null ? undefined : json['gcp_project_id'],
  };
}

export function IsolationUnitStatusToJSON(json: any): IsolationUnitStatus {
  return IsolationUnitStatusToJSONTyped(json, false);
}

export function IsolationUnitStatusToJSONTyped(
  value?: IsolationUnitStatus | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    aws_account_id: value['awsAccountId'],
    azure_subscription_id: value['azureSubscriptionId'],
    conditions:
      value['conditions'] == null
        ? undefined
        : (value['conditions'] as Array<any>).map(ConditionToJSON),
    gcp_project_id: value['gcpProjectId'],
  };
}
